import Vue from 'vue'

// ----------------------------------------------------------------------------
// Vue Material
// ----------------------------------------------------------------------------
import {
  MdApp,
  MdAvatar,
  MdBadge,
  MdButton,
  MdCard,
  MdCheckbox,
  MdChips,
  MdContent,
  MdDialog,
  MdDialogAlert,
  MdIcon,
  MdField,
  MdMenu,
  MdList,
  MdProgress,
  MdRadio,
  MdRipple, // MdTableの警告抑制のため
  MdSnackbar,
  MdSpeedDial,
  MdSteppers,
  MdSwitch,
  MdTable,
  MdTabs,
  MdToolbar,
  MdEmptyState,
} from 'vue-material/dist/components'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(MdApp)
Vue.use(MdAvatar)
Vue.use(MdBadge)
Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdContent)
Vue.use(MdCheckbox)
Vue.use(MdChips)
Vue.use(MdDialog)
Vue.use(MdDialogAlert)
Vue.use(MdIcon)
Vue.use(MdField)
Vue.use(MdMenu)
Vue.use(MdList)
Vue.use(MdProgress)
Vue.use(MdRadio)
Vue.use(MdRipple)
Vue.use(MdSnackbar)
Vue.use(MdSpeedDial)
Vue.use(MdSteppers)
Vue.use(MdSwitch)
Vue.use(MdTable)
Vue.use(MdTabs)
Vue.use(MdToolbar)
Vue.use(MdEmptyState)

// ----------------------------------------------------------------------------
// Scroll Spy
// ----------------------------------------------------------------------------
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

// ----------------------------------------------------------------------------
// Animation
// ----------------------------------------------------------------------------
import 'animate.css'

// ----------------------------------------------------------------------------
// Icons
// ----------------------------------------------------------------------------
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBookReader,
  faCaretRight,
  faCheckSquare,
  faCircle,
  faDownload,
  faFileDownload,
  faFileUpload,
  faFileExcel,
  faFileCsv,
  faFileAlt,
  faFolder,
  faFolderOpen,
  faHeart,
  faMinusSquare,
  faPaperPlane,
  faSignOutAlt,
  faUpload,
  faUser,
  faStar,
} from '@fortawesome/free-solid-svg-icons'
import { faSquare } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faBookReader)
library.add(faCaretRight)
library.add(faCheckSquare)
library.add(faCircle)
library.add(faDownload)
library.add(faFileDownload)
library.add(faFileUpload)
library.add(faFileAlt)
library.add(faFileExcel)
library.add(faFileCsv)
library.add(faFolder)
library.add(faFolderOpen)
library.add(faHeart)
library.add(faMinusSquare)
library.add(faPaperPlane)
library.add(faSignOutAlt)
library.add(faSquare)
library.add(faUpload)
library.add(faUser)
library.add(faStar)
Vue.component('font-awesome-icon', FontAwesomeIcon)
